import React from 'react';
import { FormTemplateQuestionFieldsKindEnum } from 'graphql-common';
import CheckBoxGroup from '@lib/components/CheckBoxGroup/CheckBoxGroup';
import { ComponentProps, defaultProps } from '../types';

export default function CheckboxPreview({ options }: ComponentProps) {
  const preparedOptions = options.map(({ values }) => ({
    value: values[0],
    label: values[0],
  }));
  return (
    <CheckBoxGroup
      options={preparedOptions}
      value={undefined}
      name={FormTemplateQuestionFieldsKindEnum.Checkbox}
      {...defaultProps}
    />
  );
}
